/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CallDealerModalFragment_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontCallButton_viewer$ref: FragmentReference;
export type StorefrontCallButton_viewer = {|
  +$fragmentRefs: CallDealerModalFragment_viewer$ref,
  +$refType: StorefrontCallButton_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontCallButton_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CallDealerModalFragment_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3a42a9a031c08b6d3f0d91564b56804c';
module.exports = node;
